var _path, _path2, _rect, _circle, _circle2, _rect2, _circle3, _rect3, _circle4, _rect4, _circle5, _circle6, _rect5, _circle7, _rect6, _circle8, _rect7, _circle9, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDrug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.9807 89L85.9807 111.517L71.2583 103.017C65.0405 99.4268 62.9101 91.4761 66.5 85.2583C70.0898 79.0405 78.0405 76.9101 84.2583 80.5L98.9807 89Z",
    fill: "#FFC114"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.9092 112.053L87.6725 110.731L102.411 119.24C107.256 122.038 113.29 120.909 116.83 116.841C117.419 116.975 118.017 117.025 118.608 116.994C114.738 122.273 107.431 123.901 101.632 120.553L86.9092 112.053ZM120.121 104.268C119.061 101.735 117.193 99.5154 114.632 98.0364L99.9092 89.5364L99.1725 90.8124L113.911 99.3218C115.892 100.465 117.404 102.109 118.379 104.002C118.962 104.01 119.548 104.098 120.121 104.268Z",
    fill: "#B58900"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 96.6838,
    y: 104.882,
    width: 0.794101,
    height: 3.959,
    rx: 0.397051,
    transform: "rotate(165 96.6838 104.882)",
    fill: "#A4A4A5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100.04,
    cy: 97.087,
    r: 2,
    transform: "rotate(30 100.04 97.087)",
    fill: "#C5E4E3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.4064,
    cy: 105.381,
    r: 3,
    transform: "rotate(30 96.4064 105.381)",
    fill: "#9AD3AF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 98.446,
    y: 105.97,
    width: 1.5,
    height: 3.91844,
    rx: 0.75,
    transform: "rotate(-105 98.446 105.97)",
    fill: "#A4A4A5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.786,
    cy: 103.868,
    r: 3.5,
    transform: "rotate(30 104.786 103.868)",
    fill: "#57BFBF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 104.804,
    y: 106.836,
    width: 1.5,
    height: 3,
    rx: 0.75,
    transform: "rotate(-15 104.804 106.836)",
    fill: "#A4A4A5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.665,
    cy: 111.881,
    r: 4,
    transform: "rotate(30 107.665 111.881)",
    fill: "#CFAC7F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 113.855,
    y: 110.589,
    width: 2,
    height: 3.37393,
    rx: 1,
    transform: "rotate(83.2042 113.855 110.589)",
    fill: "#A4A4A5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.276,
    cy: 110.502,
    r: 5.5,
    transform: "rotate(30 118.276 110.502)",
    fill: "#3FA7BA"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.9485,
    cy: 85.4868,
    r: 1.5,
    transform: "rotate(30 84.9485 85.4868)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 85.6313,
    y: 85.3037,
    width: 10,
    height: 1,
    transform: "rotate(30 85.6313 85.3037)",
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.9485,
    cy: 97.6112,
    r: 1.5,
    transform: "rotate(30 77.9485 97.6112)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 78.6313,
    y: 97.4281,
    width: 10,
    height: 1,
    transform: "rotate(30 78.6313 97.4281)",
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.6543,
    cy: 88.781,
    r: 1.5,
    transform: "rotate(30 72.6543 88.781)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 75.0693,
    y: 89.5979,
    width: 17,
    height: 1,
    transform: "rotate(30 75.0693 89.5979)",
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.9846,
    cy: 87.8167,
    r: 1.5,
    transform: "rotate(30 78.9846 87.8167)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6675 87.6337L83.1316 89.6337L85.4617 95.5978L84.1625 94.848L82.6316 90.4997L79.1675 88.4997L79.6675 87.6337Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5168 18.4204C49.9242 13.75 59.5867 11.0654 69.8707 11.0001V32.1745C68.97 32.332 68.1809 32.8142 67.6286 33.496L41.5168 18.4204Z",
    fill: "#86D5D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.853 19.4938C109.294 24.5915 116.362 31.7352 121.368 40.238L103.28 50.681C102.677 49.985 101.82 49.5154 100.853 49.4171L100.853 19.4938Z",
    fill: "#A2DADB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9856 37.163L97.5789 50.7846C98.1315 50.0982 98.9235 49.6125 99.828 49.4543L99.828 19.2711L73.8804 34.252C74.1058 34.731 74.2318 35.2662 74.2318 35.8307C74.2318 36.3002 74.1447 36.7494 73.9856 37.163Z",
    fill: "#86D5D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9001 11.0031C81.1416 11.1114 90.7602 13.8176 99.1282 18.4938L73.3198 33.3943C72.7174 32.703 71.8632 32.2369 70.9001 32.1389V11.0031Z",
    fill: "#86D5D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1043 34.3734L40.9473 19.2716L40.9473 49.4184C41.9143 49.5168 42.7715 49.9863 43.3743 50.6823L67.0076 37.0377C66.8777 36.6594 66.8071 36.2535 66.8071 35.8312C66.8071 35.3137 66.913 34.8209 67.1043 34.3734Z",
    fill: "#57C4CB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9262 19.3414C31.4081 24.427 24.2732 31.5892 19.2205 40.1291L37.6772 50.7851C38.2298 50.0987 39.0217 49.613 39.9262 49.4549L39.9262 19.3414Z",
    fill: "#57C4CB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7019 41.0145C13.9327 49.4029 11.1518 59.0692 11 69.3723L37.0575 54.328C36.9252 53.9467 36.8533 53.5372 36.8533 53.1109C36.8533 52.5973 36.9576 52.1081 37.1462 51.6633L18.7019 41.0145Z",
    fill: "#57C4CB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9175 84.014V56.7667C38.9289 56.5938 38.0749 56.0298 37.5207 55.2401L11.5015 70.2623L37.6544 85.3617C38.2076 84.6661 39.0053 84.1735 39.9175 84.014Z",
    fill: "#57C4CB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11 71.1533C11.1518 81.4564 13.9327 91.1226 18.7019 99.5111L37.0649 88.9091C36.9279 88.5218 36.8533 88.105 36.8533 87.6707C36.8533 87.1651 36.9544 86.6831 37.1375 86.2438L11 71.1533Z",
    fill: "#3299A0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2205 100.397C24.2732 108.937 31.4081 116.099 39.9262 121.184L39.9263 91.3269C38.9453 91.1553 38.0968 90.5987 37.5423 89.8185L19.2205 100.397Z",
    fill: "#3299A0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8707 129.526C59.5867 129.46 49.9242 126.776 41.5168 122.105L67.4932 107.108C68.0478 107.883 68.8935 108.436 69.8707 108.607V129.526Z",
    fill: "#3299A0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.087 103.534L43.5161 89.9253C42.9102 90.7166 41.9929 91.257 40.9473 91.3633L40.9473 121.254L67.0225 106.2C66.8831 105.809 66.8071 105.389 66.8071 104.951C66.8071 104.449 66.9066 103.97 67.087 103.534Z",
    fill: "#3299A0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1282 122.033C90.7602 126.709 81.1416 129.415 70.9001 129.524V108.644C71.9419 108.538 72.8562 108.001 73.4622 107.215L99.1282 122.033Z",
    fill: "#037C84"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M129.517 71.3019C129.342 81.5035 126.589 91.077 121.881 99.399L103.928 89.0337C104.095 88.6116 104.186 88.1515 104.186 87.6701C104.186 87.1174 104.065 86.5929 103.849 86.1216L129.517 71.3019Z",
    fill: "#037C84"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M100.853 70.2621V83.9773C101.828 84.0765 102.691 84.5529 103.295 85.2583L129.269 70.2621L100.853 70.2621Z",
    fill: "#037C84"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4128 70.2634L97.5658 85.3628C98.119 84.6672 98.9166 84.1746 99.8288 84.0151V70.2634L71.4128 70.2634Z",
    fill: "#037C84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDrug);
export default __webpack_public_path__ + "static/media/Logo_drug.877ea43cde15899835c476a3d1749c4d.svg";
export { ForwardRef as ReactComponent };